<h4 class="f-w-700">{{title}}</h4>
<nav>
    <ol class="breadcrumb justify-content-sm-start align-items-center mb-0">
        <li class="breadcrumb-item">
            <a [routerLink]="['/pages/dashboard']">
                <app-feather-icons [icons]="'home'"></app-feather-icons>
            </a>
        </li>
        @if (breadcrumbs.parentBreadcrumb) {
        <li class="breadcrumb-item f-w-400">{{breadcrumbs.parentBreadcrumb}}</li>
        }
        @if (breadcrumbs.parentBreadcrumb2) {
            <li class="breadcrumb-item f-w-400"> <a [routerLink]="[link]" style="color: rgba(61, 67, 74, 0.9);">{{breadcrumbs.parentBreadcrumb2}}</a></li>
        }
        @if (breadcrumbs.parentBreadcrumbId) {
            <li class="breadcrumb-item f-w-400"> <a [routerLink]="[linkId]" style="color: rgba(61, 67, 74, 0.9);">{{ 'routes.detail_project' | translate }} {{breadcrumbs.parentBreadcrumbId}}</a></li>
        }
        @if (breadcrumbs.breadcrumbParentId2) {
            <li class="breadcrumb-item f-w-400"> <a [routerLink]="[linkParent2]" style="color: rgba(61, 67, 74, 0.9);">{{breadcrumbs.breadcrumbParentId2}}</a></li>
        }
        @if (breadcrumbs.childBreadcrumb) {
        <li class="breadcrumb-item f-w-400 active">{{breadcrumbs.childBreadcrumb}}</li>
        }
    </ol>
</nav>
